module.exports = __webpack_public_path__ + "static/logo-bf6f0fe8c7a8b33ec30cbc15f450541b.svg";